<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {findBySystemInfo} from "./api/loginMange";

export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true
    };
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    // 在页面刷新时将VUEX里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
};
</script>

<style>
@import "./assets/CSS/main.css";
</style>
<style lang="scss">
.cell .el-button--primary {
  margin: 0 10px !important;
}

.avatar-uploader {
  // line-height: 180px;
}

::v-deep .el-upload--text {
  width: 180px !important;
}

.avatar-uploader .el-upload {
  width: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  // height: 178px;
  line-height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
